import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { Project } from '@/types/project';

async function fetchProjects(): Promise<Project[]> {
  const response = await api.get<{ data: Project[] }>('/projects');
  return response.data.data || [];
}

export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: fetchProjects,
  });
}
